// extracted by mini-css-extract-plugin
export default {"container":"ContentSection_container__R1zQ+","small":"ContentSection_small__JQ1Sk"};